import UtilNumber from './UtilNumber';
import UtilMoney from './UtilMoney';
import UtilDateTime from './UtilDateTime';

export default class UtilLabel{

    static toDate = (value = null) =>{

        return UtilDateTime.toFormatBrazil({ dateTime: value }) || '-';

    }

    static toBoolean = (value = false) =>{

        return value ? 'Sim' : 'Não';

    }

    static toNumber = (value = 0) =>{

        return `${UtilNumber.toNumber(value)}`;

    }

    static toKM = (value = 0) =>{

        return `${UtilNumber.toNumber(value)} KM`;

    }

    static toPercentage = (value = 0) =>{

        return `${UtilNumber.toNumber(value)}%`;

    }

    static toMoney = (value = 0) =>{

        return `R$ ${UtilMoney.toBRL(value)}`;

    }

}